<script setup>
import { fetchWithHeaders } from "@/utils";
import { useRoute, useRouter } from "vue-router";
import { ref } from "vue";
import { toDjangoDate } from "../filters";

const router = useRouter();
const route = useRoute();

const options = ref([]);

async function searchRegistrations(search) {
    let url = `${window._env_.API_ENDPOINT}/registrations/?search=${encodeURIComponent(search)}`;
    if (route.params.sessionCode) {
        url += `&slot__session=${encodeURIComponent(route.params.sessionCode)}`;
    }
    return fetchWithHeaders(url);
}

function filterFn(val, update, abort) {
    // call abort() at any time if you can't retrieve data somehow
    update(
        async () => {
            if (val === "") {
                options.value = [];
            } else {
                try {
                    options.value = await searchRegistrations(val);
                } catch (err) {
                    abort();
                }
            }
        },

        // "ref" is the Vue reference to the QSelect
        ref => {
            if (val !== "" && ref.options.length > 0) {
                ref.setOptionIndex(-1); // reset optionIndex in case there is something selected
                ref.moveOptionSelection(1, true); // focus the first selectable option and do not update the input-value
            }
        }
    );
}

async function selected(registration) {
    if (!registration) return;

    const selectedSlot = await retrieveSlot(registration.slot);
    const selectedDate = toDjangoDate(selectedSlot.start);
    const slotIndex = await searchSlotIndex(registration.slot, selectedDate);
    router.push(
        `/admin/session/${route.params.sessionCode}/${selectedDate}/${slotIndex != -1 ? slotIndex : 0}/${
            registration.pk
        }`
    );
}

async function retrieveSlot(slotId) {
    const url = `${window._env_.API_ENDPOINT}/slots/${slotId}/`;
    const slot = await fetchWithHeaders(url);
    return slot;
}

async function searchSlotIndex(slotId, selectedDate) {
    const url = `${window._env_.API_ENDPOINT}/slots/?session=${route.params.sessionCode}&start=${selectedDate}`;
    const slots = await fetchWithHeaders(url);
    for (let i = 0; i < slots.length; i++) {
        if (slots[i].pk === slotId) {
            return i;
        }
    }
    return -1;
}
</script>
<template>
    <q-select
        dark
        color="white"
        label-color="white"
        square
        filled
        clearable
        use-input
        input-debounce="300"
        label="Chercher"
        model-value=""
        :options="options"
        @filter="filterFn"
        @update:model-value="selected"
        style="min-width: 300px"
    >
        <template v-slot:no-option>
            <q-item class="text-black bg-white">
                <q-item-section> Aucun résultat </q-item-section>
            </q-item>
        </template>
        <template v-slot:option="scope">
            <q-item v-bind="scope.itemProps" class="text-black bg-white">
                <q-item-section>
                    <q-item-label
                        >{{ scope.opt.user_data.surname }} {{ scope.opt.user_data.givenName }}
                        <span class="text-italic">{{ scope.opt.user_data.matricule }}</span></q-item-label
                    >
                </q-item-section>
            </q-item>
        </template>
    </q-select>
</template>
